export default __webpack_public_path__ + "images/ekalayamanullang.com.mp4";